import { apiRequest } from "@/lib/api";

export interface AgentRoleOption {
  value: string;
  name: string;
  role_label: string;
  default_kind: string;
}

export interface AgentMessage {
  id: string;
  turn_index: number;
  sender: "student" | "agent";
  content: string;
  meta: Record<string, unknown>;
  created_at: string;
}

export interface AgentThread {
  id: string;
  encounter_id: string;
  kind: "interconsult" | "ward_round" | "family_meeting" | "nursing_report";
  agent_role: string;
  title: string;
  closed: boolean;
  closed_at: string | null;
  messages: AgentMessage[];
}

export const teamApi = {
  listRoles: (encounterId: string) =>
    apiRequest<AgentRoleOption[]>(
      `/cases/encounters/${encounterId}/team/roles`,
    ),

  listThreads: (encounterId: string) =>
    apiRequest<AgentThread[]>(`/cases/encounters/${encounterId}/team`),

  openThread: (
    encounterId: string,
    body: { kind: string; agent_role: string; title?: string },
  ) =>
    apiRequest<AgentThread>(`/cases/encounters/${encounterId}/team/threads`, {
      method: "POST",
      body,
    }),

  sendMessage: (encounterId: string, threadId: string, message: string) =>
    apiRequest<AgentThread>(
      `/cases/encounters/${encounterId}/team/threads/${threadId}/message`,
      { method: "POST", body: { message } },
    ),

  closeThread: (encounterId: string, threadId: string) =>
    apiRequest<AgentThread>(
      `/cases/encounters/${encounterId}/team/threads/${threadId}/close`,
      { method: "POST", body: {} },
    ),
};
